import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { DescriptionReduite } from '../models/DescriptionReduite';
import { Step2 } from '../../../../shared/models/component-messages/diveAT/step2';

@Component({
  selector: 'app-description-reduite',
  templateUrl: './description-reduite.component.html'
})
export class DescriptionReduiteComponent implements OnInit {

  @Input() uid = '';
  public current_uid = 'DescriptionReduite';
  @Input() parentForm: FormGroup;
  @Input() descriptionReduite: DescriptionReduite;
  public step2 = new Step2();

  constructor() {
  }

  public ngOnInit() {
  }

  public getUid() {
    return this.uid + '_SepSep_' + this.current_uid;
  }

  cbChecked() {
    return this.parentForm.controls[this.getUid() + '_SepAtt_lieuExecutionCB']?.value;
  }
}
